import {
  IconBuilding,
  IconCoin,
  IconCoinFilled,
  IconLock,
  IconLockFilled,
  IconUserCog,
  IconUsersGroup,
} from '@tabler/icons-react';

import {
  GROUPS_HREF,
  PERMISSIONS_HREF,
  PRICES_HREF,
  SETTINGS_ACCOUNT_HREF,
  SETTINGS_SCHOOLS_HREF,
} from '../../utils/common/hrefs';
import { hasOverlap } from './utils';

import { UserGroup } from '@repo/validation';
import type { MenuOption, MenuSection } from './menu';

const accountItems: MenuOption[] = [
  {
    icon: <IconUserCog />,
    name: 'Account',
    href: SETTINGS_ACCOUNT_HREF,
    linkedEndpoints: ['settings/account'],
  },
];

const accessItems: MenuOption[] = [
  {
    icon: <IconLock />,
    iconFilled: <IconLockFilled />,
    name: 'Permissions',
    href: PERMISSIONS_HREF,
    linkedEndpoints: ['settings/access/permissions'],
  },
  {
    icon: <IconUsersGroup />,
    name: 'Groups',
    href: GROUPS_HREF,
    linkedEndpoints: ['settings/access/groups'],
  },
];

const schoolsItems: MenuOption[] = [
  {
    icon: <IconBuilding />,
    name: 'Schools',
    href: SETTINGS_SCHOOLS_HREF,
    linkedEndpoints: ['settings/schools'],
  },
];

const billingItems: MenuOption[] = [
  {
    icon: <IconCoin />,
    iconFilled: <IconCoinFilled />,
    name: 'Prices',
    href: PRICES_HREF,
    linkedEndpoints: ['settings/prices'],
  },
];

/**
 * Where the profile menu's Settings row goes. It names the Account page rather
 * than `/settings`, which only redirects there.
 */
export const SETTINGS_LANDING_HREF = accountItems[0].href;

// The settings sections a caller may open, gated as the sections themselves are
// so that none is offered to someone it turns away. Account settings belong to
// whoever is signed in, so they lead.
export const getSettingsSections = (userGroups: string[]): MenuSection[] => {
  const isAdmin = hasOverlap(userGroups, [UserGroup.Admins]);
  const isManager = hasOverlap(userGroups, [UserGroup.Managers]);

  const sections: MenuSection[] = [{ items: accountItems }];

  if (isAdmin) {
    sections.push({ header: 'Access', items: accessItems });
  }

  if (isAdmin || isManager) {
    sections.push({ header: 'Terminology', items: schoolsItems });
  }

  if (isAdmin) {
    sections.push({ header: 'Billing', items: billingItems });
  }

  return sections;
};
